/**
 * staff usecase の依存（DI）。
 *
 * - repository（汎用ファクトリ）… staff の CRUD
 * - gateway(StaffGateway) … create-staff-user Edge Function（非CRUDの外部能力）
 */
import { repository } from "@/infrastructure/repositories";
import { staffGateway } from "@/infrastructure/gateways";
import type { StaffGateway } from "@/domain/repositoryInterface/StaffGateway";

export interface StaffDeps {
  repository: typeof repository;
  gateway: StaffGateway;
}

export const staffDeps: StaffDeps = {
  repository,
  gateway: staffGateway,
};
